<template>
  <div>
    <div class="md:flex bg-background-academy text-white shadow-md mt-4 hidden
    items-center rounded-lg font-sans-serif h-20 md:h-28 text-xs md:text-base"
    :style="{ 'box-shadow': '0.5em 0.5em 1em '+tier.color}"
    :class="editable ? 'w-full' : 'w-3/4 mx-auto'">
      <div class="flex justify-center items-center border-r md:border-r-2
      border-white w-1/12 h-full">
        <span>{{ number }}</span>
      </div>
      <div class="flex items-center  border-r md:border-r-2 border-white h-full justify-center px-2"
      :class="editable ? 'w-1/4' : 'w-1/3'">
        <span>{{ tier.name }}</span>
      </div>
      <div class="flex items-center  border-r md:border-r-2 border-white justify-center h-full"
      :class="editable ? 'w-1/5' : 'w-1/3'">
        <span>{{ tier.price ? formatter.format(tier.price/100)+'/h' : 'Free' }}</span>
      </div>
      <div class="flex  border-r md:border-r-2 border-white justify-center items-center h-full px-2"
      :class="editable ? 'w-1/5' : 'w-1/3'" >
        <span v-if="tier.package"> {{$t('bookingSlots.pack')}} {{tier.no_lessons}}
          {{$t('bookingSlots.lessons')}}
        </span>
        <span v-else> {{$t('bookingSlots.single-lesson')}} </span>
      </div>
      <div class="flex items-center border-r md:border-r-2 border-white w-1/4
      justify-center px-2 h-full"
        v-if="editable">
        <span v-if="!tier.classroom_template"> No Template</span>
        <span v-else>{{ tier.classroom_template.description }}</span>
      </div>
      <div class="border-r md:border-r-2 border-white h-full flex items-center">
        <button class="flex justify-center px-4 hover:text-beige-academy-300
        transform hover:scale-110" v-if="editable"
          @click="$emit('edit', tier)">
            <edit-icon class="w-3 md:w-4" />
        </button>
      </div>
      <button class="flex justify-center px-4 hover:text-beige-academy-300
        transform hover:scale-110" v-if="editable" @click="$emit('delete', tier)">
        <bin-icon class="w-3 md:w-4" />
      </button>

    </div>
    <div class="md:hidden bg-background-academy text-white shadow-md mt-4 flex
    items-center rounded-lg font-sans-serif h-32 md:h-28 text-xs md:text-base"
    :style="{ 'box-shadow': '0.5em 0.5em 1em '+tier.color}"
    :class="editable ? 'w-full' : 'w-3/4 mx-auto'">
      <div class="flex justify-center items-center border-r md:border-r-2
      border-white w-1/12 h-full">
        <span>{{ tier.id }}</span>
      </div>
      <div class="flex flex-col items-center border-r md:border-r-2 border-white
      h-full justify-center px-2"
      :class="editable ? 'w-2/3' : 'w-2/3'">
        <span class="font-bold uppercase text-md pb-1">{{ tier.name }}</span>
        <span>{{ tier.price ? formatter.format(tier.price/100)+'/h' : 'Free' }}</span>
        <span v-if="tier.package"> {{$t('bookingSlots.pack')}} {{tier.no_lessons}}
          {{$t('bookingSlots.lessons')}}
        </span>
        <span v-else> {{$t('bookingSlots.single-lesson')}} </span>
        <div v-if="editable" class="pt-4">
          <span v-if="!tier.classroom_template"> No Template</span>
          <span v-else>{{ tier.classroom_template.description }}</span>
        </div>
      </div>
      <div class="flex w-1/3 justify-center">
        <button class="flex justify-center px-2 hover:text-beige-academy-300
          transform hover:scale-110" v-if="editable"
            @click="$emit('edit', tier)">
              <edit-icon class="w-4" />
          </button>
        <button class="flex justify-center px-2 hover:text-beige-academy-300
          transform hover:scale-110" v-if="editable" @click="$emit('delete', tier)">
          <bin-icon class="w-4" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EditIcon from '@/components/graphics/EditIcon.vue';
import BinIcon from '../graphics/BinIcon.vue';

export default {
  props: ['tier', 'editable', 'number'],

  components: {
    EditIcon,
    BinIcon,
  },
};
</script>
